import {
  COLOR_DARK_BLUE,
  COLOR_ELEVATION,
  COLOR_BACKGROUND,
  COLOR_DISABLED,
  spacing,
  radius,
} from "./../../styleConfig";
import styled from "styled-components";

interface IRadioContainer {
  state: "unselected" | "selected" | "disabled";
}

export const RadioContainer = styled.div<IRadioContainer>`
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${COLOR_BACKGROUND};
  border: 2px solid
    ${(p) => (p.state == "disabled" ? COLOR_DISABLED : COLOR_DARK_BLUE)};
  border-radius: ${radius(1)};
  cursor: ${(p) => (p.state == "disabled" ? "no-drop" : "pointer")};
  margin-right: ${spacing(1)};
  box-sizing: content-box;
`;

interface IRadioMark {
  state: "unselected" | "selected" | "disabled";
}

export const RadioMark = styled.div<IRadioMark>`
  width: 10px;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(p) =>
    p.state == "selected" ? COLOR_DARK_BLUE : COLOR_DISABLED};
  border-radius: 50%;
`;

interface IMainContainer {
  state: "unselected" | "selected" | "disabled";
}

export const MainContainer = styled.div<IMainContainer>`

  display: flex;
  justify-content: center;
  align-items: flex-end;
  width: fit-content;
  height: fit-content;
  margin: ${spacing(1)};
  cursor: ${(p) => (p.state == "disabled" ? "no-drop" : "default")};
`;

interface ILabel {
  state: "unselected" | "selected" | "disabled";
}

export const Label = styled.p<ILabel>`
  color: ${(p) => (p.state == "disabled" ? COLOR_DISABLED : "inherit")};
  font-weight: 400;
`;

export const RealRadioButton = styled.input`
  position: absolute;
  opacity: 0;
  display: none;
  top: -3000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
`;
